import React, { useState, useContext, useEffect } from 'react';
import { Card, Row, Col, Button, Modal, Table, Navbar, Container, Nav, Form } from 'react-bootstrap';
import toast from 'react-hot-toast';
import PsContext from '../../context';
import API from '../../utils/api';
import { MDBInput } from 'mdb-react-ui-kit';
import $ from 'jquery';
import { PSListItem } from '../../comp';
import { Link } from 'react-router-dom';
import AddBank from './addBank';
import EditBank from './editBank';

import axios from 'axios';
import { triggerFocus } from 'antd/lib/input/Input';
import moment from 'moment';

const tdStyle = { border: '1px solid grey', borderCollapse: 'collapse', padding: '35px' }

const BankAccounts = () => {

	const context = useContext(PsContext);
	const [validated, setValidated] = useState(false);
	const [AddUser, setAddUser] = useState(false);
	const [addModel, setAddModel] = useState(false);
	const [editReportModel, setEditReportModel] = useState(false);
	const [editModel, setEditModel] = useState(false);
	const [viewData, setViewData] = useState(false);
	const [user, setUser] = useState([]);
	const [view, setView] = useState([]);
	const [data, changeData] = useState([]);
	const [reportData, setReportData] = useState([]);
	const [imgData, setImgData] = useState([]);
	const [stData, stChangeData] = useState([]);
	const [changeDate, changeDateData] = useState([]);
	const [searchData, setSearchData] = useState([]);
	const [imageData, setImageData] = useState([]);
	const [editImageData, setEditImageData] = useState([]);
	const [typeData, setTypeData] = useState([]);
	const [staffData, setStaffData] = useState([]);
	const [loading, setIsLoading] = useState(false);
	const [btnLoading, setBtnLoading] = useState(false);
	const [adminEnquiry, setAdminEnquiry] = useState(false);

	const [printData, setPrintData] = useState([]);
	const [print, setPrint] = useState(false);

	useEffect(() => {
		listdata();
	}, []);

	const filterChange = (e) => {
		var val = e.target.value;
		var name = e.target.name;
		if (val == '') {
			changeDateData(data);
		} else {
			let ndata = data.filter(function (item) {
				return (item[name] == val);
			});
			changeDateData(ndata);
		}
	}

	const showModel = (item) => {
		setUser(item);
		var dat = imageData.filter(function (obj) {
			return (obj.group_id == item.group_id && obj.group_meeting == item.id)
		})
		setEditImageData(dat);
		setEditModel(true);
	}

	const showAddModel = () => {
		setAddModel(true);
	}


	const viewModel = (item) => {
		setUser(item);
		var dat = imageData.filter(function (obj) {
			return (obj.group_id == item.group_id && obj.group_meeting == item.id)
		})
		setEditImageData(dat);
		setViewData(true);
	}

	const listdata = () => {
		try {
			setIsLoading(true);
			API.get('v1/user/list/bankdetails').then(res => {
				if (res['data'].status == '1') {
					var d = res['data'].data;
					changeData(d);
					setIsLoading(false);
				}
				else {
					setIsLoading(false);
				}
			});
		}
		catch (error) {
			setIsLoading(false);
		}
	};

	const onSearchChange = (e) => {
		var d = data;
		let ndata = d.filter(function (item) {
			const grp_name = item.grp_name.toUpperCase();
			const s = e.target.value.toUpperCase();
			return (grp_name.indexOf(s) > -1);
		});
		setSearchData(ndata);
	}


	const handleDelete = (item, id) => {
		try {
			if (window.confirm('Do you want to Remove?')) {
				setIsLoading(true);
				API.get('v1/user/deletebankaccounts?id=' + id).then(res => {
					if (res['data'].status == '1') {
						toast.success("Deleted Successfully..!", "success");
						//var d = res['data'].data;
						var d = data;
						var index = d.findIndex(function (obj) {
							return (obj.id == id);
						});
						if (index > -1)
							d.splice(index, 1);
						setIsLoading(false);
						listdata();
					}
					else {
						toast.error("Something Went Wrong..!", "danger");
						setIsLoading(false);
					}
				});
			}
		}
		catch (error) {
			setIsLoading(false);
		}
	}

	const onFromChange = (event) => {

		var fromdate = $("#fromdate").val();
		var toMinDate = moment(fromdate).format("YYYY-MM-DD");
		if (fromdate != '') {
			$("#todate").attr('min', toMinDate);
		}
	};

	return (
		<div className="container" >
			<Navbar bg="white" expand="lg">
				<Container>
					<Navbar.Brand >Bank Accounts</Navbar.Brand>
					<Nav className="justify-content-end">
						<Button variant="success" onClick={() => { showAddModel() }} size="sm"><i className="fas fa-plus"></i>&nbsp;Add Bank</Button>
					</Nav>
				</Container>
			</Navbar>
			<Row className="text-center">
				<Col md={{ span: 2, offset: 10 }}>
					<Modal show={addModel} size="md" onHide={() => { setAddModel(false) }} backdrop="static">
						<Modal.Header closeButton >
							<Modal.Title>Add Bank</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<AddBank edit={user} afterFinish={() => { setAddModel(false) }} afterList={() => listdata()} />
						</Modal.Body>
					</Modal>
				</Col>
				<Col md={{ span: 2, offset: 10 }}>
					<Modal show={editModel} size="md" onHide={() => { setEditModel(false) }} backdrop="static">
						<Modal.Header closeButton >
							<Modal.Title>Edit Bank</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<EditBank edit={user} afterFinish={() => { setEditModel(false) }} afterList={() => listdata()} />
						</Modal.Body>
					</Modal>
				</Col>
			</Row>
			<Row>
				<Col md={12} >
					<Table className="table mt-10 table-bordered"  >
						<thead className="text-center">
							<tr>
								<th width="5%" >S.No</th>
								<th><b>Bank Name</b></th>
								<th><b>Ledger Head Type</b></th>
								<th><b>Account No</b></th>
								<th><b>Action</b></th>
							</tr>
						</thead>
						<tbody className="text-center">
							{(data.map((item, id) => {
								return <tr>
									<td>{id + 1}</td>
									<td align="left">{item.ledger_head_name}</td>
									<td align="left">{item.ledger_head_type}</td>
									<td align="left">{item.account_no}</td>
									<td>
										<Button variant="info" onClick={() => { showModel(item) }} size="sm"><i className="fas fa-edit"></i> </Button>{' '}
										<Button variant="danger" size="sm" onClick={() => handleDelete(item, item.id)}><i className="fas fa-trash"></i> </Button>{' '}
									</td>
								</tr>
							}
							))}
						</tbody>
					</Table>
				</Col>
			</Row>

		</div>
	);
};
export default BankAccounts;